module.exports = "/_next/static/images/emptySearchMobile-6fc0860a8118ea2334a67ae2f807010e.jpg";